export default "__VITE_ASSET__3Guv71HM__"